var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.shouldShowRecipientsBiometry
        ? _c("recipients-biometry", {
            attrs: {
              id: _vm.createdRecipient.id,
              name: _vm.createdRecipient.name,
            },
          })
        : _c("div", { staticClass: "el-section" }, [
            _c(
              "div",
              {
                staticClass:
                  "emd-container _highlight_header _header_spaced _footer_end",
              },
              [
                _c("div", { staticClass: "emd-container__header" }, [
                  _c("h2", { staticClass: "emd-text _size_section" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("recipients.create.title")) + " "
                    ),
                  ]),
                ]),
                _vm.showAlert
                  ? _c(
                      "div",
                      { staticClass: "emd-container__content" },
                      [
                        _c(
                          "emd-alert",
                          {
                            attrs: {
                              variant: _vm.formError ? "danger" : "success",
                              title: _vm.formError
                                ? _vm.$t("alert.error-title")
                                : _vm.$t("alert.success-title"),
                            },
                            on: {
                              cancel: function ($event) {
                                _vm.showAlert = false
                              },
                            },
                          },
                          [
                            _c("template", { slot: "content" }, [
                              _vm.formError
                                ? _c(
                                    "div",
                                    _vm._l(_vm.errors, function (error, index) {
                                      return _c("p", { key: index }, [
                                        _vm._v(" " + _vm._s(error) + " "),
                                      ])
                                    }),
                                    0
                                  )
                                : _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("recipients.create.success-msg")
                                      )
                                    ),
                                  ]),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "form",
                  {
                    attrs: { novalidate: "true", action: "javascript:void(0)" },
                    on: { submit: _vm.handleSubmit },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "emd-container__content" },
                      [
                        _c("Identification", {
                          attrs: {
                            recipient: _vm.computedRecipient,
                            default_bank_account: _vm.default_bank_account,
                            vuelidate: _vm.$v,
                          },
                        }),
                        _c("hr", { staticClass: "emd-divider eu-mb_5" }),
                        _c("Recipient", {
                          attrs: {
                            recipient: _vm.computedRecipient,
                            isCpf: _vm.isCpf,
                            vuelidate: _vm.$v,
                          },
                        }),
                        _c("hr", { staticClass: "emd-divider eu-mb_5" }),
                        _c("BankAccount", {
                          attrs: {
                            default_bank_account: _vm.default_bank_account,
                            vuelidate: _vm.$v,
                          },
                        }),
                        _c("hr", { staticClass: "emd-divider eu-mb_5" }),
                        _c("PrepaymentSettings", {
                          attrs: {
                            automatic_anticipation_settings:
                              _vm.automatic_anticipation_settings,
                            vuelidate: _vm.$v,
                          },
                        }),
                        _c("hr", { staticClass: "emd-divider eu-mb_5" }),
                        _c("TransferSettings", {
                          attrs: {
                            transfer_settings: _vm.transfer_settings,
                            transferSettingsIsInvalid:
                              _vm.transferSettingsIsInvalid,
                          },
                          on: {
                            "update:transferSettingsIsInvalid": function (
                              $event
                            ) {
                              _vm.transferSettingsIsInvalid = $event
                            },
                            "update:transfer-settings-is-invalid": function (
                              $event
                            ) {
                              _vm.transferSettingsIsInvalid = $event
                            },
                          },
                        }),
                        _vm.showManagingPartners
                          ? _c("managing-partners", {
                              attrs: {
                                isCpf: _vm.isCpf,
                                managing_partners:
                                  _vm.computedRecipient.managing_partners,
                              },
                              on: {
                                add: _vm.addManagingPartner,
                                remove: _vm.removeManagingPartner,
                              },
                            })
                          : _vm._e(),
                        _vm.showManagingPartners &&
                        _vm.computedRecipient?.managing_partners?.length
                          ? _c("SelfDeclaredLegalRepresentativeInput", {
                              attrs: { recipient: _vm.computedRecipient },
                              on: {
                                "update:recipient": function ($event) {
                                  _vm.computedRecipient = $event
                                },
                              },
                            })
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "emd-container__footer" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "emd-btn _color_primary _type_text",
                                attrs: {
                                  tag: "button",
                                  type: "button",
                                  to: { name: "recipients" },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("recipients.create.button-cancel")
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "EmdButton",
                              {
                                attrs: {
                                  color: "primary",
                                  disabled: _vm.submitIsDisabled,
                                  type: "submit",
                                },
                              },
                              [
                                _vm.loadingCreation
                                  ? _c("emd-loader")
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("recipients.create.button-ok")
                                        )
                                      ),
                                    ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }